module.exports = __webpack_public_path__ + "static/media/carousel_img3.8d338303.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/carousel_img3.png
// module id = 365
// module chunks = 0